import { useLoginVerifyQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc.hooks';
import { useGetEnabledFeaturesQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/FeaturesRpc.hooks';
import { getIsThemePreview, getPortalAccountId, getPortalInstanceId, getPreviewJwt } from '../utils/metadata';
export function useIsUngated(gate) {
  var _featuresEnabled$incl;
  const accountId = getPortalAccountId();
  const portalInstanceId = getPortalInstanceId();
  const isThemePreview = getIsThemePreview();
  const previewJwt = getPreviewJwt();
  const {
    data: loginVerifyData
  } = useLoginVerifyQuery({
    variables: {
      accountId,
      portalInstanceId
    },
    skip: isThemePreview
  });
  const {
    data: previewFeaturesData
  } = useGetEnabledFeaturesQuery({
    variables: {
      accountId,
      portalInstanceId,
      previewJwt
    },
    skip: !isThemePreview || !previewJwt
  });
  const featuresEnabled = isThemePreview ? previewFeaturesData === null || previewFeaturesData === void 0 ? void 0 : previewFeaturesData.featuresEnabled : loginVerifyData === null || loginVerifyData === void 0 ? void 0 : loginVerifyData.featuresEnabled;
  return (_featuresEnabled$incl = featuresEnabled === null || featuresEnabled === void 0 ? void 0 : featuresEnabled.includes(gate)) !== null && _featuresEnabled$incl !== void 0 ? _featuresEnabled$incl : false;
}